import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=66600de6&scoped=true"
import script from "./avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./avatar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=66600de6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66600de6",
  null
  
)

export default component.exports